import { ResourceProps } from 'react-admin';
import { Tune } from '@mui/icons-material';

const ConfigurationResource: ResourceProps = {
  icon: Tune,
  name: 'configurations',
};

export default ConfigurationResource;
